import moment from 'moment';
import {
  NOT,
  YES
} from '../../../lib/Boolean.lib';
import Core from '../../../lib/Core';
import {
  DATE_FORMAT__DATE__ISO
} from '../../../lib/Date.lib';
import useState from '../../../lib/hooks/useState.hook';
import {
  Str,
  trim
} from '../../../lib/String.lib';
import Button from '../../Layout/Wrappers/Button';
import DatePicker from '../../Layout/Wrappers/DatePicker';
import TextField from '../../Layout/Wrappers/TextField';
import {
  RejectionReasonInfo
} from '../RejectionReasonInput';
import {
  RejectionReasonsMenu
} from '../RejectionReasonsMenu';
import {
  StatusesMenu
} from '../StatusesMenu';

export default function ActionBarNotifyRecruiters({
  id,
  onSubmit = () => null,
  selected = [],
  noSubOptions,
  sendEmailsFlag = true
}) {

  const [state, updateState] = useState();

  const VALUE__STATUS = Str(state.status);
  const VALUE__HOLD_DATE = Str(state.holdDate);
  const VALUE__FORMMATTED__HOLD_DATE = Str(
    VALUE__HOLD_DATE && moment(
      VALUE__HOLD_DATE
    ).format(
      DATE_FORMAT__DATE__ISO
    )
  );
  const VALUE__REJECTION_REASON = Str(state.rejectionReason);
  const VALUE__REJECTION_REASON_ADDITIONAL_INFO = Str(state.rejectionReasonAdditionalInfo);
  const VALUE__HOLD_DETAILS = Str(state.holdDetails);


  const YES__HOLD_STATUS = YES(VALUE__STATUS.match(/h -/i));
  const YES__ENDED_STATUS = YES(VALUE__STATUS.match(/e -/i));

  const NOT__SELECTED__STATUS = NOT(trim(state.status));
  const NOT__SELECTED__REJECTION__REASON = NOT(trim(state.rejectionReason));

  return (
    <div className="">
      <div className="d-flex flex-column p-2">
        {!noSubOptions && (
          <div className="d-flex w-100 space-between">
            <StatusesMenu
              filter={/(e|h) - /i}
              className="mx-1 w-20"
              style={{ height: 30 }}
              onChange={(status) => updateState({ status })}
            />
            {YES__HOLD_STATUS && (
              <>
                <div className="d-flex flex-align-left-top w-30 mr-1">
                  <strong className="mr-1 c-cyan-darker nowrap">
                    Hold Until
                  </strong>
                  <div>
                    <DatePicker
                      value={VALUE__FORMMATTED__HOLD_DATE}
                      format={DATE_FORMAT__DATE__ISO}
                      placeholder={`Type a date`}
                      style={{ width: 280 }}
                      className="rounded"
                      onChange={(holdDate) => updateState({ holdDate: holdDate.toISOString() })}
                      popupStyle={{ zIndex: 9999 }}
                    />
                  </div>
                </div>
                <div className="d-flex flex-align-left-top w-50 d-none">
                  <strong className="mr-1 c-cyan-darker">
                    Details
                  </strong>
                  <TextField multiline small
                    rowsMax={5}
                    variant="standard"
                    value={VALUE__HOLD_DETAILS}
                    onChange={(event) => {
                      const holdDetails = event.target.value;
                      updateState({ holdDetails });
                    }}
                    onBlur={(event) => {
                      const holdDetails = trim(event.target.value);
                      updateState({ holdDetails });
                    }}
                  />
                </div>
              </>
            )}
            {YES__ENDED_STATUS && (
              <>
                <RejectionReasonsMenu
                  className="mr-1 w-30"
                  style={{ height: 30 }}
                  onChange={(rejectionReason) => updateState({
                    rejectionReason
                  })}
                >
                  Reason
                </RejectionReasonsMenu>
                <RejectionReasonInfo
                  className="flex-align-left-top w-50"
                  style={{ minHeight: 30 }}
                  onChange={(rejectionReasonAdditionalInfo) => updateState({
                    rejectionReasonAdditionalInfo
                  })}
                >
                  <span style={{ height: 30 }}>Details</span>
                </RejectionReasonInfo>
              </>
            )}
          </div>
        )}
        <Button primary
          size="large"
          className="m-auto my-2 px-8 py-3"
          style={{ minWidth: 222 }}
          disabled={!selected.length}
          onClick={event => {
            if (!noSubOptions) {
              if (NOT__SELECTED__STATUS) {
                return Core.showError('Status has not selected!');
              }
              if (YES__ENDED_STATUS && NOT__SELECTED__REJECTION__REASON) {
                return Core.showError('Reason has not selected!');
              }
            }
            onSubmit({
              status: VALUE__STATUS,
              rejectionReason: VALUE__REJECTION_REASON,
              rejectionReasonAdditionalInfo: VALUE__REJECTION_REASON_ADDITIONAL_INFO,
              holdDate: VALUE__HOLD_DATE,
              holdDetails: VALUE__HOLD_DETAILS,
            });
          }}
        >
          {sendEmailsFlag ? `Notify (${selected.length}) Recruiters` : `Close (${selected.length}) Engagements`}
        </Button>
      </div>
    </div>
  );
}